export default {
  API_URL: 'https://api.strathub.foxlisk.com'
}
